<nz-tabset nzSize="small">
	<nz-tab *appIfPermission="'query:create'" [nzTitle]="'query.create.title' | translate">
		<workflow-query-create></workflow-query-create>
	</nz-tab>
	<nz-tab *appIfPermission="'query:read'" [nzTitle]="title">
		<ng-template #title>
			<nz-badge nzShowZero [nzCount]="(opened$ | async)?.length || 0">
				<div class="withBadge">
					{{'query.edit.opened' | translate}}
				</div>
			</nz-badge>
		</ng-template>
		<workflow-query-edit [queries]="opened$ | async">
			<ng-container *appQueryEditActions="let comment; let message = message; let query = query">
				<button *appIfPermission="'query:create'" nz-button type="button" nzType="default" [disabled]="!message" (click)="comment(query.id)">
					{{'query.edit.button.comment' | translate}}
				</button>

				<button *appIfPermission="'query:respond'" nz-button type="button" nzType="primary" (click)="comment(query.id, 'responded')">
					{{'query.edit.button.respond' | translate}}
				</button>
			</ng-container>
		</workflow-query-edit>
	</nz-tab>
	<nz-tab *appIfPermission="'query:read'" [nzTitle]="title">
		<ng-template #title>
			<nz-badge nzShowZero [nzCount]="(responded$ | async)?.length || 0">
				<div class="withBadge">
					{{'query.edit.responded' | translate}}
				</div>
			</nz-badge>
		</ng-template>
		<workflow-query-edit [queries]="responded$ | async">
			<ng-container *appQueryEditActions="let comment; let message = message; let query = query">
				<button *appIfPermission="'query:create'" nz-button type="button" nzType="default" [disabled]="!message" (click)="comment(query.id)">
					{{'query.edit.button.comment' | translate}}
				</button>

				<button *appIfPermission="'query:finish'" nz-button type="button" nzType="primary" (click)="comment(query.id, 'closed')">
					{{'query.edit.button.close' | translate}}
				</button>
			</ng-container>
		</workflow-query-edit>
	</nz-tab>
</nz-tabset>
<ng-template #emptyTemplate>
	<div class="empty">
		{{'query.empty' | translate}}
	</div>
</ng-template>